import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { config } from '../../config';
import Loading from '../../components/Loading/Loading';
import Cookies from 'js-cookie';
import { useMe } from '../../context/MeContext';

const MobileLogin = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { fetchMe } = useMe();
  const token = searchParams.get('token');

  useEffect(() => {
    const doMobileLogin = async () => {
      if (!token) {
        navigate('/login');
        return;
      }
      
      try {
        const backendUrl = config.REACT_APP_BACKEND_URL;
        const response = await fetch(
          `${backendUrl}/auth/mobile-login?token=${encodeURIComponent(token)}`,
          {
            method: 'GET',
            credentials: 'include',
          },
        );

        if (!response.ok) {
          navigate('/login');
          return;
        }
        const data = await response.json();
        const accessToken = data?.payload?.access_token;
        if (accessToken) {
          Cookies.set('token', accessToken, { secure: true, sameSite: 'Strict' });
          await fetchMe();
          navigate('/');
        } else {
          navigate('/login');
        }
      } catch (e) {
        navigate('/login');
      }
    };

    doMobileLogin();
  }, [token, navigate, fetchMe]);

  return <Loading />;
};

export default MobileLogin; 